import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3346099"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-lb-shell" }
const _hoisted_2 = { class: "nge-lb-topbar" }
const _hoisted_3 = { class: "nge-lb-hero" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-hero-grid" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-hero-scanline" }, null, -1 /* HOISTED */))
const _hoisted_6 = { class: "nge-lb-hero-img-wrap" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-hero-shadow" }, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-title-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-title-rule" }),
  /*#__PURE__*/_createElementVNode("h2", { class: "nge-lb-title-treat" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-lb-title-bracket" }, "▮"),
    /*#__PURE__*/_createElementVNode("span", { class: "nge-lb-title-text" }, "LEADERBOARD"),
    /*#__PURE__*/_createElementVNode("span", { class: "nge-lb-title-bracket" }, "▮")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-title-sub" }, "RANKED // TOP CONTRIBUTORS"),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-title-rule" })
], -1 /* HOISTED */))
const _hoisted_10 = { class: "nge-lb-tabs" }
const _hoisted_11 = { class: "nge-lb-metric-toggle" }
const _hoisted_12 = { class: "nge-lb-content" }
const _hoisted_13 = { class: "nge-lb-table" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "nge-lb-th nge-lb-th--rank" }, "#", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "nge-lb-th" }, "Name", -1 /* HOISTED */))
const _hoisted_16 = { class: "nge-lb-th nge-lb-th--num" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "nge-lb-th nge-lb-th--badge" }, "★", -1 /* HOISTED */))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "nge-lb-td nge-lb-td--rank" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "nge-lb-rank-num"
}
const _hoisted_22 = { class: "nge-lb-td" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 2,
  class: "nge-lb-flag-fallback"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 3,
  class: "nge-lb-you-tag"
}
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "nge-lb-td nge-lb-td--num" }
const _hoisted_30 = { class: "nge-lb-td nge-lb-td--badge" }
const _hoisted_31 = ["src", "alt", "title"]
const _hoisted_32 = {
  key: 1,
  class: "nge-lb-badge-none"
}
const _hoisted_33 = { class: "nge-lb-topbar" }
const _hoisted_34 = { class: "nge-lb-content nge-lb-detail" }
const _hoisted_35 = { class: "nge-lb-detail-header" }
const _hoisted_36 = { class: "nge-lb-detail-name-row" }
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 2,
  class: "nge-lb-flag-fallback nge-lb-flag-fallback--detail"
}
const _hoisted_40 = { class: "nge-lb-detail-name" }
const _hoisted_41 = {
  key: 0,
  class: "nge-lb-detail-bio"
}
const _hoisted_42 = { class: "nge-lb-detail-grid" }
const _hoisted_43 = { class: "nge-lb-detail-stat" }
const _hoisted_44 = { class: "nge-lb-detail-stat-val" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "All-Time Edits", -1 /* HOISTED */))
const _hoisted_46 = { class: "nge-lb-detail-stat" }
const _hoisted_47 = { class: "nge-lb-detail-stat-val" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "Cells", -1 /* HOISTED */))
const _hoisted_49 = { class: "nge-lb-detail-stat" }
const _hoisted_50 = { class: "nge-lb-detail-stat-val" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "Merges", -1 /* HOISTED */))
const _hoisted_52 = { class: "nge-lb-detail-stat" }
const _hoisted_53 = { class: "nge-lb-detail-stat-val" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "Splits", -1 /* HOISTED */))
const _hoisted_55 = { class: "nge-lb-detail-stat" }
const _hoisted_56 = { class: "nge-lb-detail-stat-val" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "This Week", -1 /* HOISTED */))
const _hoisted_58 = { class: "nge-lb-detail-stat" }
const _hoisted_59 = { class: "nge-lb-detail-stat-val" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-lb-detail-stat-lbl" }, "This Month", -1 /* HOISTED */))
const _hoisted_61 = {
  key: 0,
  class: "nge-lb-detail-streak"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-lb-detail-streak-flame" }, "🔥", -1 /* HOISTED */))
const _hoisted_63 = { class: "nge-lb-detail-streak-count" }
const _hoisted_64 = { class: "nge-lb-detail-streak-unit" }
const _hoisted_65 = {
  key: 0,
  class: "nge-lb-detail-streak-sep"
}
const _hoisted_66 = {
  key: 1,
  class: "nge-lb-detail-streak-best"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-lb-detail-badges-label",
  style: {"color":"#ffd08a"}
}, "Edit Achievements", -1 /* HOISTED */))
const _hoisted_68 = {
  key: 1,
  class: "nge-lb-detail-badges-grid"
}
const _hoisted_69 = ["title", "onClick"]
const _hoisted_70 = { class: "nge-lb-detail-badge-img" }
const _hoisted_71 = ["src", "alt"]
const _hoisted_72 = { class: "nge-lb-detail-badge-name" }
const _hoisted_73 = {
  key: 2,
  class: "nge-lb-detail-no-badges"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-lb-detail-badges-label",
  style: {"color":"#90fff2"}
}, "Cell Achievements", -1 /* HOISTED */))
const _hoisted_75 = {
  key: 3,
  class: "nge-lb-detail-badges-grid"
}
const _hoisted_76 = ["title", "onClick"]
const _hoisted_77 = { class: "nge-lb-detail-badge-img" }
const _hoisted_78 = ["src", "alt"]
const _hoisted_79 = { class: "nge-lb-detail-badge-name" }
const _hoisted_80 = {
  key: 4,
  class: "nge-lb-detail-no-badges"
}
const _hoisted_81 = {
  key: 0,
  class: "nge-lb-detail-badge-card"
}
const _hoisted_82 = ["src", "alt"]
const _hoisted_83 = { class: "nge-lb-detail-badge-card-body" }
const _hoisted_84 = { class: "nge-lb-detail-badge-card-name" }
const _hoisted_85 = { class: "nge-lb-detail-badge-card-desc" }
const _hoisted_86 = { class: "nge-lb-detail-badge-card-thresh" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    id: "nge-lb-modal",
    class: "nge-lb-modal",
    onHide: _cache[10] || (_cache[10] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" ── LIST VIEW ─────────────────────────────────── "),
        (!$setup.selectedUser)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "nge-lb-exit nge-lb-exit--abs",
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: $setup.nurroTrophy,
                    alt: "Nurro Trophy",
                    class: "nge-lb-hero-img"
                  }, null, 8 /* PROPS */, _hoisted_7),
                  _hoisted_8
                ]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-lb-tab", { 'nge-lb-tab--active': $setup.activeTab === 'day' }]),
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.activeTab = 'day'))
                }, "24h", 2 /* CLASS */),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-lb-tab", { 'nge-lb-tab--active': $setup.activeTab === 'week' }]),
                  onClick: _cache[2] || (_cache[2] = $event => ($setup.activeTab = 'week'))
                }, "Week", 2 /* CLASS */),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-lb-tab", { 'nge-lb-tab--active': $setup.activeTab === 'alltime' }]),
                  onClick: _cache[3] || (_cache[3] = $event => ($setup.activeTab = 'alltime'))
                }, "All Time", 2 /* CLASS */)
              ]),
              _createCommentVNode(" Metric toggle: edits vs completions "),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-lb-metric", { 'nge-lb-metric--active': $setup.metric === 'edits' }]),
                  onClick: _cache[4] || (_cache[4] = $event => ($setup.setMetric('edits')))
                }, "Edits", 2 /* CLASS */),
                _createElementVNode("button", {
                  class: _normalizeClass(["nge-lb-metric", { 'nge-lb-metric--active': $setup.metric === 'completions' }]),
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.setMetric('completions')))
                }, "Cells", 2 /* CLASS */)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("th", _hoisted_16, _toDisplayString($setup.metricLabel), 1 /* TEXT */),
                      _hoisted_17
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rankedUsers, (user, idx) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: user.id,
                        class: _normalizeClass(["nge-lb-row", { 'nge-lb-row--you': user.id === 'amy' || user.id === $setup.backendStore.userId }]),
                        onClick: $event => ($setup.selectUser(user))
                      }, [
                        _createElementVNode("td", _hoisted_19, [
                          ($setup.RANK_MEDAL[idx + 1])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.RANK_MEDAL[idx + 1]), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(idx + 1), 1 /* TEXT */))
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createCommentVNode(" Use live prefs flag for the logged-in user's row "),
                          ($setup.isEyewireFlag($setup.userFlag(user)))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "nge-lb-flag-img nge-lb-flag-img--logo",
                                src: $setup.pyrIcon
                              }, null, 8 /* PROPS */, _hoisted_23))
                            : ($setup.flagImgUrl($setup.userFlag(user)))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  class: "nge-lb-flag-img",
                                  src: $setup.flagImgUrl($setup.userFlag(user))
                                }, null, 8 /* PROPS */, _hoisted_24))
                              : (_openBlock(), _createElementBlock("span", _hoisted_25, "🌐")),
                          _createElementVNode("span", {
                            class: "nge-lb-name nge-lb-name--clickable",
                            onClick: _withModifiers($event => ($setup.openFullProfile(user.id)), ["stop"]),
                            title: "View profile"
                          }, _toDisplayString(user.name), 9 /* TEXT, PROPS */, _hoisted_26),
                          (user.id === 'amy' || user.id === $setup.backendStore.userId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "you"))
                            : _createCommentVNode("v-if", true),
                          (user.stats.currentStreak > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 4,
                                class: "nge-lb-streak",
                                title: `${user.stats.currentStreak}-day streak`
                              }, " 🔥" + _toDisplayString(user.stats.currentStreak), 9 /* TEXT, PROPS */, _hoisted_28))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", _hoisted_29, _toDisplayString($setup.editCountForTab(user).toLocaleString()), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_30, [
                          ($setup.topBadge(user))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: $setup.getBadgeUrl($setup.topBadge(user)?.imageKey ?? ''),
                                alt: $setup.topBadge(user)?.name ?? '',
                                title: $setup.topBadge(user)?.name ?? '',
                                class: "nge-lb-badge-img"
                              }, null, 8 /* PROPS */, _hoisted_31))
                            : (_openBlock(), _createElementBlock("span", _hoisted_32, "—"))
                        ])
                      ], 10 /* CLASS, PROPS */, _hoisted_18))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" ── DETAIL VIEW ────────────────────────────────── "),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "nge-lb-back",
                  onClick: _cache[6] || (_cache[6] = $event => ($setup.selectedUser = null))
                }, "← Back"),
                _createElementVNode("button", {
                  class: "nge-lb-exit",
                  onClick: _cache[7] || (_cache[7] = $event => ($setup.emit('hide')))
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    ($setup.isEyewireFlag($setup.selectedUser.flag))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "nge-lb-flag-img nge-lb-flag-img--detail nge-lb-flag-img--logo",
                          src: $setup.pyrIcon
                        }, null, 8 /* PROPS */, _hoisted_37))
                      : ($setup.flagImgUrl($setup.selectedUser.flag))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "nge-lb-flag-img nge-lb-flag-img--detail",
                            src: $setup.flagImgUrl($setup.selectedUser.flag)
                          }, null, 8 /* PROPS */, _hoisted_38))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, "🌐")),
                    _createElementVNode("div", _hoisted_40, _toDisplayString($setup.selectedUser.name), 1 /* TEXT */)
                  ]),
                  ($setup.selectedUser.bio)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($setup.selectedUser.bio), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "nge-lb-view-profile",
                    onClick: _cache[8] || (_cache[8] = $event => ($setup.openFullProfile($setup.selectedUser.id)))
                  }, "View Full Profile →")
                ]),
                _createCommentVNode(" Stats grid (2-column) "),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, _toDisplayString($setup.selectedUser.stats.editsAllTime.toLocaleString()), 1 /* TEXT */),
                    _hoisted_45
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString($setup.selectedUser.stats.cellsSubmitted.toLocaleString()), 1 /* TEXT */),
                    _hoisted_48
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, _toDisplayString($setup.selectedUser.stats.mergesAllTime.toLocaleString()), 1 /* TEXT */),
                    _hoisted_51
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString($setup.selectedUser.stats.splitsAllTime.toLocaleString()), 1 /* TEXT */),
                    _hoisted_54
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, _toDisplayString($setup.selectedUser.stats.editsThisWeek.toLocaleString()), 1 /* TEXT */),
                    _hoisted_57
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, _toDisplayString($setup.selectedUser.stats.editsThisMonth.toLocaleString()), 1 /* TEXT */),
                    _hoisted_60
                  ])
                ]),
                _createCommentVNode(" Streak "),
                ($setup.selectedUser.stats.currentStreak > 0 || $setup.selectedUser.stats.longestStreak > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("span", _hoisted_63, _toDisplayString($setup.selectedUser.stats.currentStreak), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_64, "day" + _toDisplayString($setup.selectedUser.stats.currentStreak === 1 ? '' : 's') + " current", 1 /* TEXT */),
                      ($setup.selectedUser.stats.longestStreak > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, " · "))
                        : _createCommentVNode("v-if", true),
                      ($setup.selectedUser.stats.longestStreak > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, " Best: " + _toDisplayString($setup.selectedUser.stats.longestStreak) + "d ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Edit Achievements "),
                _hoisted_67,
                ($setup.earnedBuildingForUser.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedBuildingForUser, (badge) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: badge.id,
                          class: _normalizeClass(["nge-lb-detail-badge", { 'nge-lb-detail-badge--selected': $setup.selectedBadgeId === badge.id }]),
                          title: badge.name + ' — click for details',
                          onClick: $event => ($setup.onDetailBadgeClick(badge.id))
                        }, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("img", {
                              src: $setup.getBadgeUrl(badge.imageKey),
                              alt: badge.name,
                              class: "nge-lb-detail-badge-icon"
                            }, null, 8 /* PROPS */, _hoisted_71)
                          ]),
                          _createElementVNode("div", _hoisted_72, _toDisplayString(badge.name), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_69))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_73, "No edit badges earned yet")),
                _createCommentVNode(" Cell Achievements "),
                _hoisted_74,
                ($setup.earnedExplorationForUser.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earnedExplorationForUser, (badge) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: badge.id,
                          class: _normalizeClass(["nge-lb-detail-badge", { 'nge-lb-detail-badge--selected': $setup.selectedBadgeId === badge.id }]),
                          title: badge.name + ' — click for details',
                          onClick: $event => ($setup.onDetailBadgeClick(badge.id))
                        }, [
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("img", {
                              src: $setup.getBadgeUrl(badge.imageKey),
                              alt: badge.name,
                              class: "nge-lb-detail-badge-icon"
                            }, null, 8 /* PROPS */, _hoisted_78)
                          ]),
                          _createElementVNode("div", _hoisted_79, _toDisplayString(badge.name), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_76))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_80, "No cell badges earned yet")),
                _createCommentVNode(" Badge detail card "),
                _createVNode(_Transition, { name: "lb-badge-detail" }, {
                  default: _withCtx(() => [
                    ($setup.selectedBadgeDef())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _createElementVNode("img", {
                            src: $setup.getBadgeUrl($setup.selectedBadgeDef()?.imageKey ?? ''),
                            alt: $setup.selectedBadgeDef()?.name ?? '',
                            class: "nge-lb-detail-badge-card-icon"
                          }, null, 8 /* PROPS */, _hoisted_82),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, _toDisplayString($setup.selectedBadgeDef()?.name), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_85, _toDisplayString($setup.selectedBadgeDef()?.description), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_86, " Unlocked at " + _toDisplayString($setup.selectedBadgeDef()?.threshold.toLocaleString()) + " " + _toDisplayString($setup.selectedBadgeDef()?.track === 'building' ? 'edits' : 'cells completed'), 1 /* TEXT */)
                          ]),
                          _createElementVNode("button", {
                            class: "nge-lb-detail-badge-card-close",
                            onClick: _cache[9] || (_cache[9] = _withModifiers($event => ($setup.selectedBadgeId = null), ["stop"]))
                          }, "×")
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}